import { createClient } from '@connectrpc/connect';
import { AqoraService as Aqora } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { transport } from '~/services/api/service-transport';

export const aqoraClient = createClient(Aqora, transport);
